<template>
  <div class="col-md-12 d-flex justify-content-center align-self-center"></div>
</template>

<script>
export default {
  created() {
    this.$store
      .dispatch('destroyToken')
      .then(() => {
        // localStorage.clear();
        localStorage.removeItem('acc');
        localStorage.removeItem('app_token');
        localStorage.removeItem('mainSearch');
      })
      .then(() => {
        this.$router.push('/');

        this.$toasted.success('You are successfully logged out.', {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 10000,
        });
        location.reload();
      })
      .catch((err) => {
        this.$router.push('/');

        this.$toasted.error(err, {
          theme: 'bubble',
          icon: 'fa-exclamation-circle',
          position: 'bottom-right',
          duration: 10000,
        });
        location.reload();
      });
  },
};
</script>
